import axios from 'axios';
import { toast } from 'react-toastify';
import { LOGIN_SUCCESS, LOGIN_ERROR, IS_LOADING, SET_CURRENT_USER, LOGOUT_SUCCESS } from './Type';
import store from "../store";
import { apiHeader } from './ApiHeader';
import 'react-toastify/dist/ReactToastify.css';
import { baseUrlPostGres } from '../constant';
import HandleError from './HandleError';

toast.configure();

export const setCurrentUser = (token) => {
    return (
        store.dispatch({
            type: SET_CURRENT_USER,
            payload: token
        })
    )
}

export const LoginAction = (formData) => (dispatch) => {
    dispatch({ type: IS_LOADING })
    axios
        .post(`${baseUrlPostGres()}/api/login`, formData, {
            headers: apiHeader(true)
        })
        .then(response => {
            const res = response.data.success
            const payload = {
                id: res.id,
                name: res.name,
                email: res.email,
                token: res.token
            }
            dispatch({ type: LOGIN_SUCCESS, payload: response })
            dispatch(setCurrentUser(payload))
            localStorage.setItem("security_auth", JSON.stringify(payload));
            toast.success("You are successfully logged in", { theme: "colored" })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            toast.error(errors.response.data.error, { theme: "colored" })
            dispatch({
                type: LOGIN_ERROR,
                payload: errors.response.data
            })
        })
}

export const LogoutAction = () => (dispatch) => {
    dispatch({ type: IS_LOADING })
    axios
        .get(`${baseUrlPostGres()}/api/logout`, {
            headers: apiHeader()
        })
        .then(response => {
            HandleError(response.data)
            dispatch({ type: LOGOUT_SUCCESS, payload: response })
            dispatch(setCurrentUser({}))
            localStorage.removeItem("security_auth");
            toast.success(response.data.success, { theme: "colored" })
            setTimeout(() => {
                window.location.href = "/login"
            }, 500);
        })
        .catch(error => {
            HandleError(error.response.data)
        })
}